import {createAsyncThunk} from '@reduxjs/toolkit'
import {ItemResultType, Review} from 'redux/thunk/types'
import {getConfigKey, prepareHeaders} from 'utility/Api'
import apiConfigs from 'Api/api-config'

export const saveReportReviews = createAsyncThunk(
  'costObjectReport/saveReportReviews',
  // Declare the type your function argument here:
  async (formData: any): Promise<any> => {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const baseUrl = apiConfigs[getConfigKey()].apiHost
    const apiPath = apiConfigs[getConfigKey()].paths.apiPath
    const filteredReviews = formData.reportConfig
    const response = await fetch(`${baseUrl}/${apiPath}/reviews/save`, {
      method: 'POST',
      headers: await prepareHeaders(headers),
      body: JSON.stringify({ reportConfig: filteredReviews })
    })
    const responseData = await response.json()

    return responseData
  }
)
export const runReport = async (page: number = 1, formData: any, sapResponseData: any): Promise<any> => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  const baseUrl = apiConfigs[getConfigKey()].apiHost
  const apiPath = apiConfigs[getConfigKey()].paths.apiPath
  const prepareData = (formData: any): any => {
    const supervisors = formData.supervisors.map((supervisor: any) => {
      return supervisor.id
    })
    const profitCenters = formData.profitCenters.map((profitCenter: any) => {
      return profitCenter.id
    })
    const costObjects = formData.costObjects.map((costObject: any) => {
      return costObject.id
    })
    return {
      fiscalPeriod: formData.fiscalPeriod,
      supervisors,
      profitCenters,
      costObjects
    }
  }
  const requestHeaders = await prepareHeaders(headers)
  let responseLoop;
  try {
    responseLoop = await fetch(`${baseUrl}/${apiPath}/costObjectReport?page=${page}`, {
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify(prepareData(formData))
    });
    if (responseLoop.status === 400 || responseLoop.status === 403 || responseLoop.status === 500) {
      const errorData = await responseLoop.json();
      const error = {message: errorData.message || 'Error fetching cost object report', statusCode: 400};
      error.statusCode = responseLoop.status;
      throw error;
    }
  } catch (error) {
    console.error('Error fetching cost object report:', error);
    throw error;
  }
  const sapResponseDataLoop = await responseLoop.json()
  let nextPage = parseInt(sapResponseData.nextPage)

  nextPage = parseInt(sapResponseDataLoop.nextPage)
  sapResponseData.row = sapResponseData.row.concat(sapResponseDataLoop.row)
  if (!isNaN(nextPage) && sapResponseDataLoop.row.length > 0 && sapResponseDataLoop.row[0].TYPE !== 'E') {
    if (nextPage !== 0) {
      await runReport(nextPage, formData, sapResponseData)
    }
  }
  return sapResponseData
}
export const runCostObjectReport = createAsyncThunk(
  'costObjectReport/runCostObjectReport',
  // Declare the type your function argument here:
  async (formData: any): Promise<any> => {
    console.log('Running Cost Object Report with formData:', formData)
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const baseUrl = apiConfigs[getConfigKey()].apiHost
    const apiPath = apiConfigs[getConfigKey()].paths.apiPath
    const sapResponseData = await runReport(1, formData, {row: []}).catch((e) => {
      let errorMessage = e.message || ''

      if (/not allowed/i.test(errorMessage)) {
        errorMessage = 'User not allowed to execute RFC'
      } else if (/secret/i.test(errorMessage)) {
        errorMessage = 'Error with Secret Service'
      } else if (/failed/i.test(errorMessage)) {
        errorMessage = 'Error with RFC or Cost object'
      } else if (/unexpected/i.test(errorMessage)) {
        errorMessage = 'Error with RFC'
      }
      else if (/valid/i.test(errorMessage) || /missing/i.test(errorMessage)) {
        errorMessage = 'Error with query parameters'
      }
      else if(/line limit/i.test(errorMessage)) {
        errorMessage = 'Line limit exceeded.'
      }
      else if (/fiscal period/i.test(errorMessage)) {
        errorMessage = 'No fiscal period'
      }
      else {
        errorMessage = 'Check logs for details'
      }

      switch (e.statusCode) {
        case 400:
          console.log('Bad Request Error: ', e.message)
          throw new Error(errorMessage)
        case 403:
          console.log('Forbidden Error: ', e.message)
          throw new Error(errorMessage)
        case 500:
          console.log('Internal Server Error: ', e.message)
          throw new Error(errorMessage)
        default:
          console.log('Unexpected Error: ', e.message)
          throw new Error(errorMessage)
      }
    })
    const requestHeaders = await prepareHeaders(headers)

    let error: any

    if (sapResponseData.row?.length === 0) {
      throw new Error('No data found for the selected criteria')
    }

    if (sapResponseData.row[0].MESSAGE !== null && sapResponseData.row[0].MESSAGE !== undefined) {
      error = sapResponseData.row[0].MESSAGE
      return {
        fiscalPeriod: formData.fiscalPeriod,
        results: [],
        error,
        formData
      }
    }

    const finalData: ItemResultType[] = sapResponseData.row.map((data: any) => {
      let coupaPoNumber = data.PO_COUP.split('COUPA')[1]
      if (coupaPoNumber === undefined) {
        coupaPoNumber = data.PO_COUP
      }
      return {
        id: data.BELNR,
        profitCenter: data.PRCTR,
        costObjectName: `${data.COST_OBJECT as string} - ${data.OBJNAME as string}`,
        transactionType: data.TRANS,
        docTypeDescription: data.DOCTYPE,
        glAccount: data.COST_ELEMENT,
        docDate: data.DOCDATE,
        docNumber: data.DOCNR,
        lineItemText: data.DESCR,
        reference: data.REFNR,
        poNumber: data.PO_DOC,
        transactionDetail: data.DETAIL,
        actualAmount: data.AMOUNT,
        reviewed: Review.NONE,
        risk: data.RISK,
        period: data.PERIO_TEXT,
        riskReason: data.REASON,
        coupaPoNumber: coupaPoNumber,
        reason: {
          type: '',
          comment: ''
        },
        expanded: false,
        type: 'MASTER'
      }
    })

    /*
        DATA MIGRATION - BY REFBN
    */
    let oldIds = ''
    finalData.forEach((result: ItemResultType) => {
      const splitParsedId = result.docNumber.split(',')[0].split('-')
      const parsedId = splitParsedId[0] + '-' + splitParsedId[1]

      oldIds += `${parsedId},`
    })
    const oldReviewResponse = await fetch(`${baseUrl}/${apiPath}/reviews`, {
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify({
        docIds: oldIds
      })
    })
    oldIds = oldIds.slice(0, -1)

    const oldDocReviews = await oldReviewResponse.json()
    if (oldDocReviews[0].length > 0) {
      oldDocReviews[0].forEach((result: any) => {
        const findObject = finalData.find((data: ItemResultType) => {
          const localDocNum = `${data.docNumber.split(',')[0]}`
          const splitParsedId = localDocNum.split('-')
          const parsedId = splitParsedId[0] + '-' + splitParsedId[1]
          const splitResultId = result.RE_ID.split('-')
          const resultId = splitResultId[0] + '-' + splitResultId[1]

          return parsedId === resultId
        })
        if (findObject != null) {
          findObject.reviewed = result.STATUS
          findObject.reason.type = result.REASON_CODE
          findObject.reason.comment = result.CGCOMMENT
        }
      })
    }

    /*
        DATA MIGRATION - BY COUPA REFBN
    */
    let newIds = ''
    finalData.forEach((result: ItemResultType) => {
      const splitParsedId = result.docNumber.split(',')[0].split('-')
      const parsedId = splitParsedId[0] + '-' + splitParsedId[1]
      newIds += `${parsedId},`
    })
    const newReviewResponse = await fetch(`${baseUrl}/${apiPath}/reviews`, {
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify({
        docIds: newIds
      })
    })
    newIds = newIds.slice(0, -1)

    const newDocReviews = await newReviewResponse.json()
    if (newDocReviews[0].length > 0) {
      newDocReviews[0].forEach((result: any) => {
        const findObject = finalData.find((data: ItemResultType) => {
          const localDocNum = `${data.docNumber.split(',')[1]}`
          const splitParsedId = localDocNum.split('-')
          const parsedId = splitParsedId[0] + '-' + splitParsedId[1]
          const splitResultId = result.RE_ID.split('-')
          const resultId = splitResultId[0] + '-' + splitResultId[1]
          return parsedId === resultId
        })
        if (findObject != null) {
          findObject.reviewed = result.STATUS
          findObject.reason.type = result.REASON_CODE
          findObject.reason.comment = result.CGCOMMENT
        }
      })
    }
    /*
        REVIEWS BY BELNR
    */
    let ids = ''
    finalData.forEach((result: ItemResultType) => {
      const splitParsedId = result.id.split('-')
      const parsedId = splitParsedId[0] + '-' + splitParsedId[1]
      ids += `${parsedId},`
    })
    ids = ids.slice(0, -1)
    const reviewResponse = await fetch(`${baseUrl}/${apiPath}/reviews`, {
      method: 'POST',
      headers: requestHeaders,
      body: JSON.stringify({
        docIds: ids
      })
    })
    const docReviews = await reviewResponse.json()
    if (docReviews[0].length > 0) {
      docReviews[0].forEach((result: any) => {
        const findObject = finalData.find((data: ItemResultType) => {
          const splitParsedId = data.id.split('-')
          const parsedId = splitParsedId[0] + '-' + splitParsedId[1]
          const splitResultId = result.RE_ID.split('-')
          const resultId = splitResultId[0] + '-' + splitResultId[1]
          return parsedId === resultId
        })
        if (findObject != null) {
          findObject.reviewed = result.STATUS
          findObject.reason.type = result.REASON_CODE
          findObject.reason.comment = result.CGCOMMENT
        }
      })
    }

    // Inferred return type: Promise<MyData>
    return {
      fiscalPeriod: formData.fiscalPeriod,
      results: finalData,
      formData
    }
  }
)

export const saveSelectedProfitCenters = createAsyncThunk(
  'costObjectReport/saveSelectedProfitCenters',
  // Declare the type your function argument here:
  async (selected: any[]) => {
    // const response = await fetch(``)
    // // Inferred return type: Promise<MyData>
    // return (await response.json()) as CostObjectReportResult
    return selected
  }
)

export const saveSelectedSupervisors = createAsyncThunk(
  'costObjectReport/saveSelectedSupervisors',
  // Declare the type your function argument here:
  async (selected: any[]) => {
    // const response = await fetch(``)
    // // Inferred return type: Promise<MyData>
    // return (await response.json()) as CostObjectReportResult
    return selected
  }
)

export const clearCostObjectReport = createAsyncThunk(
  'costObjectReport/clearCostObjectReport',
  // Declare the type your function argument here:
  async () => {
    // const response = await fetch(``)
    // // Inferred return type: Promise<MyData>
    // return (await response.json()) as CostObjectReportResult
    return []
  }
)

export const saveFinancialPeriod = createAsyncThunk(
  'costObjectReport/saveFinancialPeriod',
  // Declare the type your function argument here:
  async (period: string) => {
    // const response = await fetch(``)
    // // Inferred return type: Promise<MyData>
    // return (await response.json()) as CostObjectReportResult
    return period
  }
)
